import { render, staticRenderFns } from "./popup.vue?vue&type=template&id=ef11265c&"
import script from "./popup.vue?vue&type=script&lang=ts&"
export * from "./popup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef11265c')) {
      api.createRecord('ef11265c', component.options)
    } else {
      api.reload('ef11265c', component.options)
    }
    module.hot.accept("./popup.vue?vue&type=template&id=ef11265c&", function () {
      api.rerender('ef11265c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/popup/popup.vue"
export default component.exports